import './user.css';

export default function User() {
    return(
        <h2 className='userName'>João Lucas Melo de Souza</h2>
    );
}